
import Vue from 'vue'
import { initialize, route, authenticated, me } from '@/middleware/middleware'

export default Vue.extend({
  middleware: [route, authenticated, me, initialize],
  head(): any {
    const title = this.App.state.current?.title
    const titleTemplate = title ? '%s - ' + process.env.APPLICATION_NAME : null

    return {
      title,
      titleTemplate
    }
  },
  computed: {
    __bottom(): boolean {
      return this.App.state.bottom && this.$vuetify.breakpoint.mobile && !this.App.state.mobile
    },
    __drawer(): boolean {
      return !this.App.state.mobile
    }
  },
  created() {
    this.App.state.layout = 'default'
  },
  methods: {
    resize() {
      const bottom = document.getElementById('m-app-bottom')
      this.App.state.bottomHeight = (bottom?.offsetHeight || 0) + 'px'
    }
  }
})
